
import { Pricing } from "@/types/pricing"
import axios from "./productInstance"

export default async ({
  id,
  price_model,
  price,
  discount,
  discount_type,
  discount_model,
  max_price_total,
  min_price_total,
    name
}: Pricing) => {
  const payload = {
    price_model,
    price,
    discount,
    discount_type,
    discount_model,
    max_price_total,
    min_price_total,
    name
  }
  console.log(payload)

  try {
    const response: any = await axios.put(`/pricing/${id}`, payload)
    return response.data
  } catch (error) {
    return null
  }
}
